import { faSave } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { useAppSelector } from '../../../App/Hooks/reduxHooks'
import { PersonKnowledge } from '../util/PersonKnowledge'
import { useUpdatePersonKnowledgeMutation } from '../util/usePersonKnowledgeQuery'

type Props = {
  personUuid: string
  personKnowledgeServer: PersonKnowledge[]
}

const MenuContainer = styled.div`
  position: fixed;
  z-index: 1000;
  padding: 15px 30px;
  display: flex;
  justify-content: center;
  background-color: #2164db;
  color: white;
  bottom: 20px;
  right: 40px;
  border-radius: 40px;
  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12),
    0 2px 4px -1px rgba(0, 0, 0, 0.2);
  cursor: pointer;
`

const ButtonText = styled.p`
  cursor: pointer;
  margin: 0;
`

export const StickyMenu: React.FC<Props> = ({
  personKnowledgeServer,
  personUuid,
}) => {
  const queryClient = useQueryClient()
  const knowledgeFromLocalStore = useAppSelector(
    state => state.hr.knowledgeRequests,
  )
  const updateKnowledgeData = useUpdatePersonKnowledgeMutation(queryClient)
  const { t } = useTranslation()

  const handleSave = () => {
    const initialData = personKnowledgeServer
    const updatedData = knowledgeFromLocalStore.list
    if (initialData && updatedData) {
      const updatedItems = updatedData.filter(
        (item, index) =>
          item.customDuration !== initialData[index].customDuration ||
          item.isActive !== initialData[index].isActive,
      )
      if (updatedItems.length !== 0) {
        const transformForApi = updatedData.map(item => {
          return {
            activity_uuid: item.name,
            custom_duration: item.customDuration,
            is_active: item.isActive,
          }
        })
        updateKnowledgeData.mutate({
          uuid: personUuid,
          knowledge: transformForApi,
        })
      }
    }
  }

  return (
    <MenuContainer onClick={() => handleSave()}>
      <ButtonText>{t('Save')}</ButtonText>
    </MenuContainer>
  )
}
